<template>
	<div id="app">
		<div class="home-container" v-wechat-title='$route.meta.title'>
			<div class="header-container">
				<HeaderComponent />
			</div>
			<div class="body-container">
				<div class="aside-container">
					<MenusComponent :parent="0" :children="0" />
				</div>
				<div class="content-container">
					<div class="page-tabs-box">
						<span class="page-tabs-prev" @click="tabsPrev"></span>
						<div class="page-tabs-wrap" ref="tabsWrap">
							<ul>
								<li v-for="(tab,$index) in pageTabs" :key="$index" class="page-tabs-items"
									:class="{'page-tabs-selected':$index == pageTabs_curIndex,'page-tabs-items':$index != pageTabs_curIndex}">
									<a href="javascript:void(0);"
										:class="{'page-tabs-selected':$index == pageTabs_curIndex,'page-tab-name':$index != pageTabs_curIndex}"
										@click="switchPage($event,tab,$index)">
										{{tab.title}}
									</a>
									<i class="page-tab-close-but" @click="closePagTab($event,tab,$index)"
										v-if="$index!=0"></i>
								</li>
							</ul>
						</div>
						<span class="page-tabs-next" @click="tabsNext"></span>
					</div>
					<div class="main-content st-auto-scroll">
						<div class="main-content-warp">
							<keep-alive exclude="OrderMap,OrderDetail">
								<router-view></router-view>
							</keep-alive>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	import HeaderComponent from '@/components/HeaderComponent.vue'
	import MenusComponent from '@/components/MenusComponent.vue'
	import FooterComponent from '@/components/FooterComponent.vue'
	import { mapGetters } from 'vuex'

	export default {
		name: 'Main',
		props: [],
		components: {
			HeaderComponent,
			MenusComponent,
			FooterComponent
		},
		computed: {
			...mapGetters([
				'pageTabs',
				'pageTabs_curIndex'
			])
		},
		data() {
			return {
				//pageTabs: []
			}
		},
		created() {
			// this.pageTabs = [{
			// 	index: 0,
			// 	name: '首页',
			// 	title: '',
			// 	path: '/home',
			// 	icon: '',
			// 	selected: true,
			// 	childrens: []
			// }]

		},
		methods: {

			tabsPrev() {
				let moveNum = 60
				this.$refs.tabsWrap.style.left = '-60px';
			},
			tabsNext() {
				this.$refs.tabsWrap.style.left = '60px';
			},

			switchPage(e, item, index) {
				this.$store.dispatch('common/switchTab', index)
			},
			closePagTab(e, item, index) {
				this.$store.dispatch('common/deleteTab', index)
			}
		},
		mounted() {
			if (window.performance.navigation.type == 1) {
				this.$router.push('/')
			}
		},
	}

</script>

<style scoped>
.home-container {
	width: 100%;
	height: auto;
	/* min-height: 870px; */
}

.header-container {
	width: 100%;
	height: 60px;
}

.body-container {
	position: relative;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	height: calc(100vh - 60px);
	overflow: hidden;
	display: flex;
}

.aside-container {
	width: 96px;
	height: 100%;
	background-color: #fff;
}

.content-container {
	padding: 0 8px;
	box-sizing: border-box;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 96px;

}

.page-tabs-box {
	width: 100%;
	overflow: hidden;
	height: 33px;
	background: #FFF;
	margin-bottom: 8px;
	position: relative;
}

.page-tabs-wrap {
	/* width: 600px; */
	height: 32px;
	position: relative;
}

.page-tabs-prev {
	position: absolute;
	left: 0;
	top: 0;
	width: 10px;
	height: 32px;
	background: chocolate;
	cursor: pointer;
	z-index: 1;
	display: none;
}

.page-tabs-next {
	position: absolute;
	top: 0;
	right: 0;
	width: 10px;
	height: 32px;
	background: chocolate;
	cursor: pointer;
	display: none;
}

.page-tabs-box ul {
	/* width: 600px; */
	display: flex;
	flex-wrap: nowrap;
}

.page-tabs-box ul li {
	padding: 0 30px;
	border-bottom: 1px solid #B7B7B7FF;
	min-width: 30px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	color: #333333FF;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.page-tabs-box ul li a {
	/* display: inline-block; 
width: 100%; 
min-width: 10px;
height: 32px;
line-height: 32px;
text-align: center;
color: #333333FF;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap; */
}

.page-tabs-items {
	position: relative;
}

.page-tab-name {
	color: #333333;
}

.page-tabs-box ul li.page-tabs-selected {
	border-bottom: 1px solid #FF5B3E;
}

.page-tabs-box ul li.page-tabs-selected a {
	color: #FF5B3E;
}

.page-tab-close-but {
	display: block;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background: #999999;
	overflow: hidden;
	position: absolute;
	right: 8px;
	top: 50%;
	margin-top: -7px;
}

.page-tab-close-but::before,
.page-tab-close-but::after {
	display: block;
	width: 2px;
	height: 10px;
	content: '';
	position: absolute;
	top: 3px;
	left: 6px;
	background: #fff;
}

.page-tab-close-but::before {
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
}

.page-tab-close-but::after {
	-webkit-transform: rotate(-45deg);
	transform: rotate(-45deg);
}

.page-tab-close-but:hover {
	cursor: pointer;
}

.main-content {
	position: absolute;
	bottom: 0;
	right: 8px;
	top: 40px;
	left: 8px;
	overflow: hidden;
	/* overflow: auto; */
}

.main-content-warp {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	/* min-width: 1249px; */
}
</style>